import { createContext, useContext } from 'react'

type OpenRoleProviderProps = {
    children: React.ReactNode
    value: boolean
}

const OpenRoleContext = createContext<{ openRolesExist: boolean }>({ openRolesExist: false })

export function OpenRolesProvider({ children, value }: OpenRoleProviderProps) {
    return (
        <OpenRoleContext.Provider value={{ openRolesExist: value }}>
            {children}
        </OpenRoleContext.Provider>
    )
}

export function useOpenRolesExist() {
    const { openRolesExist } = useContext(OpenRoleContext)

    if (openRolesExist === undefined) {
        throw new Error('useOpenRolesExist must be within a OpenRoleProvider')
    }

    return openRolesExist
}
